import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import blue from '../../assets/images/data/mark_grp.svg';
import red from '../../assets/images/data/mark_grp_rd.svg';

import './data_styles/dataupper.css';
import Chartt from '../graph/chartt';

export default function DataUpper() {
  return (
    <>
      <Container className='mt-5 mb-5 data_upper'>
        <Row className='data_up'>
              <Col lg={3} md={6} className='dt_col'>
              <div className="data_first_data data_data d-flex align-items-center gap-2">
              <div className="data_fst">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="data_fst_grap">
                <Chartt />
              </div>
            </div>
              </Col>
            
              <Col lg={3} md={6} className='dt_col'>
              <div className="data_second_data data_data d-flex align-items-center gap-2">
              <div className="data_scnd">
                <p>ET/USDT</p>
                <h6 className='data_up_h6 m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="data_scnd_grap">
                <Chartt />
              </div>
            </div>
              </Col>
           
            <Col lg={3} md={6} className='dt_col'>
            <div className="data_third_data data_data d-flex align-items-center gap-2">
              <div className="data_trd">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="data_trd_grap">
                <Chartt />
              </div>
            </div>
            </Col>

            <Col lg={3} md={6} className='dt_col'>
            <div className="data_forth_data data_data d-flex align-items-center gap-2">
              <div className="data_fth">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="data_fth_grap">
                <Chartt />
              </div>
            </div>            
            </Col>
        </Row>
      </Container>
    </>
  )
}